import { useEffect, useState } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import printerimg from "../../../../assets/print.png";
import {
  useGetItemDetailsDataMutation,
} from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import Attachment from "../../../../utils/Attachment";
const ViewForm = () => {
  const [tab, settab] = useState(1);
  const navigate = useNavigate();
   const location = useLocation();
      const IdData = location.state?.ItemId;
      const [podata, setpodata] = useState('')
  // console.log('ids:',IdData)
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

 

  // for Tab1
  const [SupplierName, setSupplierName] = useState("");
  const [SupplierGroup_list, setSupplierGroup_list] = useState([]);
  const [select_SupplierGroup, setselect_SupplierGroup] = useState("");
  const [SupplierType, setSupplierType] = useState("");
  const [Territory_list, setTerritory_list] = useState([]);
  const [select_Territory, setselect_Territory] = useState("");
  const [IsTransporter, setIsTransporter] = useState("");
  const [BillingCurrency_list, setBillingCurrency_list] = useState([]);
  const [select_BillingCurrency, setselect_BillingCurrency] = useState("");
  const [DefaultCompanyBankAccount_list, setDefaultCompanyBankAccount_list] = useState([]);
  const [select_DefaultCompanyBankAccount, setselect_DefaultCompanyBankAccount] = useState("");
    const [DefaultPriceList_list, setDefaultPriceList_list] = useState([]);
  const [select_DefaultPriceList, setselect_DefaultPriceList] = useState("");
  const [IsInternalSupplier, setIsInternalSupplier] = useState("");
    const [RepresentsCompany_list, setRepresentsCompany_list] = useState([]);
  const [select_RepresentsCompany, setselect_RepresentsCompany] = useState("");
  const [Website, setWebsite] = useState("");
  const [SupplierDetails, setSupplierDetails] = useState("");

  // for Tab2
    const [SupplierPrimaryAddress_list, setSupplierPrimaryAddress_list] = useState([]);
  const [select_SupplierPrimaryAddress, setselect_SupplierPrimaryAddress] = useState("");
  const [SupplierPrimaryContact_list, setSupplierPrimaryContact_list] = useState([]);
  const [select_SupplierPrimaryContact, setselect_SupplierPrimaryContact] = useState("");

// for Tab3
  const [TaxID, setTaxID] = useState("");
  const [TaxCategory_list, setTaxCategory_list] = useState([]);
  const [select_TaxCategory, setselect_TaxCategory] = useState("");
  const [TaxWithholdingCategory_list, setTaxWithholdingCategory_list] = useState([]);
  const [select_TaxWithholdingCategory, setselect_TaxWithholdingCategory] = useState("");
  const [GSTIN_UIN, setGSTIN_UIN] = useState("");
  const [PAN, setPAN] = useState("");
  const [GSTCategory, setGSTCategory] = useState("");

// for Tab4
const [AllowPurchaseInvoiceCreationWithoutPurchaseOrder, setAllowPurchaseInvoiceCreationWithoutPurchaseOrder] = useState("");
const [IsFrozen, setIsFrozen] = useState("");
const [AllowPurchaseInvoiceCreationWithoutPurchaseReceipt, setAllowPurchaseInvoiceCreationWithoutPurchaseReceipt] = useState("");
const [Disabled, setDisabled] = useState("");
const [BlockSupplier, setBlockSupplier] = useState("");
const [HoldType, setHoldType] = useState("");
const [ReleaseDate, setReleaseDate] = useState("");


  const [fieldErrors, setFieldErrors] = useState({
    SupplierName: false,
    SupplierGroup: false,
    SupplierType: false,
    Territory: false,
  });
  // for api

 const [AttachmentsList, setAttachmentsList] = useState([]); // ✅ Make sure it's an array
 const [status, setStatus] = useState("");
  const [po_response, setpo_response] = useState("");
  const [itemDetails, { data, isLoadin }] = useGetItemDetailsDataMutation();

    useEffect(() => {
			if (IdData) {
				itemDetails({ doctype: "Supplier", name: IdData })
					.unwrap()
					.then((response) => {
						const item = response.docs?.[0]; // ✅ safely access first item
						const docinfo = response.docinfo;

						if (!item) return;
						setpodata(response);
            console.log(item, "Api response");
            //Tab1
						setSupplierName(item.supplier_name);
						setselect_SupplierGroup(item.supplier_group);
						setSupplierType(item.supplier_type);
						setselect_Territory(item.country);
						setIsTransporter(item.is_transporter);

						setselect_BillingCurrency(item.default_currency);
						setselect_DefaultCompanyBankAccount(item.default_bank_account);
						setselect_DefaultPriceList(item.default_price_list);
						setIsInternalSupplier(item.is_internal_supplier);
						setselect_RepresentsCompany(item.represents_company);
						setSupplierDetails(item.supplier_details);
						setWebsite(item.website);

            //Tab2
						setselect_SupplierPrimaryAddress(item.__onload.addr_list[0]);
            setselect_SupplierPrimaryContact(item.__onload.contact_list[0]);
            setSupplierPrimaryAddress_list(item.__onload.addr_list)
            setSupplierPrimaryContact_list(item.__onload.contact_list)
            // console.log("Address List", item.__onload.addr_list);
            // console.log("Conact List",item.__onload.contact_list);
            
            //Tab3
						setTaxID(item.tax_id);
						setselect_TaxCategory(item.tax_category);
						setselect_TaxWithholdingCategory(item.tax_withholding_category);
						setGSTIN_UIN(item.gstin);
						setPAN(item.pan);
						setGSTCategory(item.gst_category);

						setAllowPurchaseInvoiceCreationWithoutPurchaseOrder(
							item.allow_purchase_invoice_creation_without_purchase_order
						);
						setAllowPurchaseInvoiceCreationWithoutPurchaseReceipt(
							item.allow_purchase_invoice_creation_without_purchase_receipt
						);
						setIsFrozen(item.is_frozen);
						setDisabled(item.disabled);
						setBlockSupplier(item.on_hold);
						setHoldType(item.hold_type);
						setReleaseDate(item.release_date);

						setAttachmentsList(docinfo.attachments); // ✅ Correct place
						setStatus(item.disabled);
					})
					.catch((err) => {
						console.error("API Error:", err);
					});
			} else {
				console.warn("No Id Data found in location state");
			}
		}, [IdData, itemDetails]);
  


  return (
		<FormLayout
			title="View Supplier"
			breadcrumbs={[
				{ label: "Supplier" },
				{ label: "Supplier List", url: "/master/supplier/supplier-list" },
			]}
			status={"hide"}
			finalStep={finalstep}
			actionButtons={
				<>
					{/* <Button
            to="/master/supplier/supplier-list"
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrFormPrevious"
            iconSize={12}
          >
            Back
          </Button> */}

					<Button
						to="/"
						className="px-2"
						imgSrc={printerimg}
						imgStyle={{ width: "21px" }}
					/>
				</>
			}
		>
			<div
				className="d-flex flex-column"
				style={{ width: "100%", backgroundColor: "#fff", flexGrow: "1" }}
			>
				<div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
					<div className="d-flex justify-content-between align-items-end ">
						<ul
							className="nav nav-tabs"
							style={{ color: "white", border: "none" }}
						>
							<li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
								<a
									className={
										tab == 1
											? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
											: "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
									}
									onClick={() => {
										settab(1);
									}}
									href="javascript:void(0);"
								>
									General Details
									{tab == 1 ? (
										<GetIcon iconName="MdKeyboardArrowDown" size={15} />
									) : (
										<GetIcon iconName="MdKeyboardArrowRight" size={15} />
									)}
								</a>
							</li>
							<li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner">
								<a
									className={
										tab == 2
											? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
											: "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
									}
									onClick={() => {
										settab(2);
									}}
									href="javascript:void(0);"
								>
									Address & Contact{" "}
									{tab == 2 ? (
										<GetIcon iconName="MdKeyboardArrowDown" size={15} />
									) : (
										<GetIcon iconName="MdKeyboardArrowRight" size={15} />
									)}
								</a>
							</li>
							<li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner">
								<a
									className={
										tab == 3
											? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
											: "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
									}
									onClick={() => {
										settab(3);
									}}
									href="javascript:void(0);"
								>
									Tax{" "}
									{tab == 3 ? (
										<GetIcon iconName="MdKeyboardArrowDown" size={15} />
									) : (
										<GetIcon iconName="MdKeyboardArrowRight" size={15} />
									)}
								</a>
							</li>
							<li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner">
								<a
									className={
										tab == 4
											? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
											: "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
									}
									onClick={() => {
										settab(4);
									}}
									href="javascript:void(0);"
								>
									Settings{" "}
									{tab == 4 ? (
										<GetIcon iconName="MdKeyboardArrowDown" size={15} />
									) : (
										<GetIcon iconName="MdKeyboardArrowRight" size={15} />
									)}
								</a>
							</li>
						</ul>

						<Attachment doctype="Supplier" docname={IdData} />
					</div>
				</div>

				<div
					className="row d-flex justify-content-between"
					style={{ marginTop: "14px" }}
				>
					<div
						className="col-12 "
						style={{
							visibility: tab == 1 ? "visible" : "hidden",
							height: tab == 1 ? "auto" : "0px",
						}}
					>
						<div className="sidebarbox m-0 px-4 py-2">
							<Tab1
								IdData={IdData}
								SupplierName={{
									SupplierName: SupplierName,
									setSupplierName: setSupplierName,
									SupplierName: SupplierName,
									Error: fieldErrors.SupplierName,
								}}
								IsTransporter={{
									IsTransporter: IsTransporter,
									setIsTransporter: setIsTransporter,
									IsTransporter: IsTransporter,
									Error: fieldErrors.IsTransporter,
								}}
								SupplierGroup={{
									SupplierGroup_list: SupplierGroup_list,
									setselect_SupplierGroup: setselect_SupplierGroup,
									select_SupplierGroup: select_SupplierGroup,
									Error: fieldErrors.SupplierGroup,
								}}
								SupplierType={{
									SupplierType: SupplierType,
									setSupplierType: setSupplierType,
									Error: fieldErrors.SupplierType,
								}}
								Territory={{
									Territory_list: Territory_list,
									setselect_Territory: setselect_Territory,
									select_Territory: select_Territory,
									Error: fieldErrors.Territory,
								}}
								BillingCurrency={{
									BillingCurrency_list: BillingCurrency_list,
									setselect_BillingCurrency: setselect_BillingCurrency,
									select_BillingCurrency: select_BillingCurrency,
									Error: fieldErrors.BillingCurrency,
								}}
								DefaultCompanyBankAccount={{
									DefaultCompanyBankAccount_list:
										DefaultCompanyBankAccount_list,
									setselect_DefaultCompanyBankAccount:
										setselect_DefaultCompanyBankAccount,
									select_DefaultCompanyBankAccount:
										select_DefaultCompanyBankAccount,
									Error: fieldErrors.DefaultCompanyBankAccount,
								}}
								DefaultPriceList={{
									DefaultPriceList_list: DefaultPriceList_list,
									setselect_DefaultPriceList: setselect_DefaultPriceList,
									select_DefaultPriceList: select_DefaultPriceList,
									Error: fieldErrors.DefaultPriceList,
								}}
								IsInternalSupplier={{
									IsInternalSupplier: IsInternalSupplier,
									setIsInternalSupplier: setIsInternalSupplier,
									IsInternalSupplier: IsInternalSupplier,
									Error: fieldErrors.IsInternalSupplier,
								}}
								RepresentsCompany={{
									RepresentsCompany_list: RepresentsCompany_list,
									setselect_RepresentsCompany: setselect_RepresentsCompany,
									select_RepresentsCompany: select_RepresentsCompany,
									Error: fieldErrors.RepresentsCompany,
								}}
								Website={{
									Website: Website,
									setWebsite: setWebsite,
									Website: Website,
									Error: fieldErrors.Website,
								}}
								SupplierDetails={{
									SupplierDetails: SupplierDetails,
									setSupplierDetails: setSupplierDetails,
									SupplierDetails: SupplierDetails,
									Error: fieldErrors.SupplierDetails,
								}}
							/>
						</div>
					</div>

					<div
						className="col-12"
						style={{
							visibility: tab == 2 ? "visible" : "hidden",
							height: tab == 2 ? "auto" : "0px",
						}}
					>
						<div className="sidebarbox m-0 px-4 py-2">
							<Tab2
								IdData={IdData}
                SupplierPrimaryAddress={{
                  SupplierPrimaryAddress_list: SupplierPrimaryAddress_list,
                  select_SupplierPrimaryAddress: select_SupplierPrimaryAddress,
                  setSupplierPrimaryAddress_list: setSupplierPrimaryAddress_list,
                  setselect_SupplierPrimaryAddress: setselect_SupplierPrimaryAddress,
									Error: fieldErrors.SupplierPrimaryAddress,
								}}
								SupplierPrimaryContact={{
									select_SupplierPrimaryContact: select_SupplierPrimaryContact,
                  SupplierPrimaryContact_list: SupplierPrimaryContact_list,
									setSupplierPrimaryContact_list: setSupplierPrimaryContact_list,
                  setselect_SupplierPrimaryContact: setselect_SupplierPrimaryContact,
									Error: fieldErrors.SupplierPrimaryContact,
								}}
							/>
						</div>
					</div>

					<div
						className="col-12"
						style={{
							visibility: tab == 3 ? "visible" : "hidden",
							height: tab == 3 ? "auto" : "0px",
						}}
					>
						<div className="sidebarbox m-0 px-4 py-2">
							<Tab3
								IdData={IdData}
								TaxID={{
									TaxID: TaxID,
									setTaxID: setTaxID,
									TaxID: TaxID,
									Error: fieldErrors.TaxID,
								}}
								TaxCategory={{
									TaxCategory_list: TaxCategory_list,
									setselect_TaxCategory: setselect_TaxCategory,
									select_TaxCategory: select_TaxCategory,
									Error: fieldErrors.TaxCategory,
								}}
								TaxWithholdingCategory={{
									TaxWithholdingCategory_list: TaxWithholdingCategory_list,
									setselect_TaxWithholdingCategory:
										setselect_TaxWithholdingCategory,
									select_TaxWithholdingCategory: select_TaxWithholdingCategory,
									Error: fieldErrors.TaxWithholdingCategory,
								}}
								GSTIN_UIN={{
									GSTIN_UIN: GSTIN_UIN,
									setGSTIN_UIN: setGSTIN_UIN,
									GSTIN_UIN: GSTIN_UIN,
									Error: fieldErrors.GSTIN_UIN,
								}}
								PAN={{
									PAN: PAN,
									setPAN: setPAN,
									PAN: PAN,
									Error: fieldErrors.PAN,
								}}
								GSTCategory={{
									GSTCategory: GSTCategory,
									setGSTCategory: setGSTCategory,
									GSTCategory: GSTCategory,
									Error: fieldErrors.GSTCategory,
								}}
							/>
						</div>
					</div>

					<div
						className="col-12"
						style={{
							visibility: tab == 4 ? "visible" : "hidden",
							height: tab == 4 ? "auto" : "0px",
						}}
					></div>
				</div>
			</div>

			<ApiResponseBox
				poptype={ptype}
				show={showError}
				errorMessage={error}
				onClose={() => setShowError(false)}
			/>
		</FormLayout>
	);
};

export default ViewForm;
